import { classNames } from 'libs/react';
import { useEffect } from 'libs/react';
import { useIf } from 'libs/react';
import { useRef } from 'libs/react';
import { useState } from 'libs/react';
import { DropdownMenu } from 'components/DropdownMenu';
import { Icon } from 'components/Icon';
import { Text } from 'components/Text';
import { React } from 'libs/react';
import { createPortal } from 'react-dom';
import './DropdownButton.scss';
/**
 * @component DropdownButton
 * @since 1.0.0
 * @hidden
 */
export function DropdownButton(props) {
    const { style, size, value, disabled, options, placeholder } = Object.assign({ size: 'normal', style: 'normal', placeholder: '' }, props);
    const [active, setActive] = useState(false);
    const [menuPosition, setMenuPosition] = useState(null);
    const [maxMenuHeight, setMaxMenuHeight] = useState(undefined);
    const triggerRef = useRef(null);
    const menuRef = useRef(null);
    /**
     * @function onClick
     * @since 1.0.0
     * @hidden
     */
    function onClick() {
        if (disabled) {
            return;
        }
        setActive((active) => !active);
    }
    /**
     * @function onSelect
     * @since 1.0.0
     * @hidden
     */
    function onSelect(value) {
        if (props.onSelect) {
            props.onSelect(value);
        }
        setActive(false);
    }
    useIf(active, props.onOpen, props.onClose);
    useEffect(() => {
        if (!active)
            return;
        function updateMenuGeometry() {
            if (!triggerRef.current)
                return;
            const rect = triggerRef.current.getBoundingClientRect();
            const padding = 16;
            const spaceBelow = window.innerHeight - rect.bottom - padding;
            const approxRow = 52;
            const estimatedMenu = options.length * approxRow + 24;
            const maxH = Math.max(spaceBelow, 0);
            const cappedHeight = maxH > 0
                ? maxH
                : Math.min(estimatedMenu, Math.floor(window.innerHeight * 0.85));
            setMaxMenuHeight(cappedHeight);
            setMenuPosition({
                top: rect.top,
                left: rect.left,
                width: rect.width,
                height: rect.height
            });
        }
        updateMenuGeometry();
        function handleClickOutside(e) {
            var _a, _b;
            const target = e.target;
            if (((_a = triggerRef.current) === null || _a === void 0 ? void 0 : _a.contains(target)) || ((_b = menuRef.current) === null || _b === void 0 ? void 0 : _b.contains(target))) {
                return;
            }
            setActive(false);
        }
        function handleScroll() {
            updateMenuGeometry();
        }
        function handleResize() {
            updateMenuGeometry();
        }
        document.addEventListener('click', handleClickOutside, true);
        window.addEventListener('scroll', handleScroll, true);
        window.addEventListener('resize', handleResize);
        return () => {
            document.removeEventListener('click', handleClickOutside, true);
            window.removeEventListener('scroll', handleScroll, true);
            window.removeEventListener('resize', handleResize);
        };
    }, [active, options.length]);
    let picto = null;
    let image = null;
    let label = null;
    let infos = null;
    let color = null;
    const current = options.find((option) => option.value == value);
    if (current) {
        picto = current.picto;
        image = current.image;
        label = current.label;
        infos = current.infos;
        color = current.color;
    }
    else if (placeholder) {
        label = placeholder;
    }
    const className = classNames('dropdown-button', 'dropdown-button--' + style, 'dropdown-button--' + size, { 'dropdown-button--is-active': active }, { 'dropdown-button--has-label': label }, { 'dropdown-button--has-infos': infos }, { 'dropdown-button--has-picto': picto }, { 'dropdown-button--has-value': value }, props.className);
    const isHex = color === null || color === void 0 ? void 0 : color.startsWith('#');
    return (React.createElement("div", { ref: triggerRef, className: className },
        React.createElement("div", { className: "dropdown-button-main", onClick: onClick },
            React.createElement("div", { className: "dropdown-button-head" },
                color && (React.createElement("div", { className: !isHex ? classNames('dropdown-button-color', 'dropdown-button-color--' + color) : 'dropdown-button-color', style: isHex ? { backgroundColor: color } : undefined })),
                picto && React.createElement(Icon, { className: "dropdown-button-picto", value: picto }),
                image && React.createElement(Icon, { className: "dropdown-button-image", value: image })),
            React.createElement("div", { className: "dropdown-button-body" },
                color && (React.createElement("div", { className: !isHex ? classNames('dropdown-button-color', 'dropdown-button-color--' + color) : 'dropdown-button-color', style: isHex ? { backgroundColor: color } : undefined })),
                label && React.createElement(Text, { className: "dropdown-button-label", value: label }),
                infos && React.createElement(Text, { className: "dropdown-button-infos", value: infos })),
            React.createElement("div", { className: "dropdown-button-foot" },
                React.createElement(Icon, { className: "dropdown-button-arrow", value: "chevron-down" }))),
        active && menuPosition && createPortal(React.createElement("div", { ref: menuRef, style: {
                position: 'fixed',
                top: menuPosition.top,
                left: menuPosition.left,
                width: menuPosition.width,
                height: menuPosition.height,
                zIndex: 9999,
                overflow: 'visible'
            } },
            React.createElement(DropdownMenu, { items: options, onSelect: onSelect, value: value, openUpward: false, maxHeight: maxMenuHeight })), document.body)));
}
